import { NavLink } from "react-router-dom";
import ListItemIcon from "@mui/material/ListItemIcon";
import Typography from "@mui/material/Typography";
import * as React from "react";
import { FC } from "react";
import { useTheme } from "@mui/material/styles";
import { alpha, ListItemButton } from "@mui/material";

interface Props {
    routeTo: string;
    label: string;
    icon: React.ReactNode;
    onNavigate?: () => void;
}

const DrawerListItem: FC<Props> = ({ routeTo, label, icon, onNavigate }) => {
    const theme = useTheme();

    return (
        <ListItemButton
            sx={{
                padding: 0,
                "& .active .MuiListItemIcon-root": {
                    color: theme.palette.secondary.main,
                },
            }}
        >
            <NavLink
                to={routeTo}
                onClick={onNavigate}
                style={({ isActive }) => ({
                    width: "100%",
                    display: "inline-flex",
                    padding: "1em",
                    alignItems: "center",
                    textDecoration: "none",
                    color: isActive
                        ? theme.palette.primary.main
                        : alpha(theme.palette.primary.main, 0.7),
                    backgroundColor: isActive
                        ? alpha(theme.palette.primary.main, 0.15)
                        : "transparent",
                    backdropFilter: isActive ? "blur(5px)" : "none",
                    borderRight: isActive
                        ? `4px solid ${theme.palette.primary.main}`
                        : "4px solid transparent",
                    fontWeight: isActive ? 600 : 400,
                })}
                // ✅ className can also be a function if you prefer to style via sx
                className={({ isActive }) => (isActive ? "active" : undefined)}
            >
                <ListItemIcon sx={{ minWidth: 40 }}>{icon}</ListItemIcon>
                <Typography variant="button" sx={{ alignSelf: "center" }}>
                    {label}
                </Typography>
            </NavLink>
        </ListItemButton>
    );
};

export default DrawerListItem;
